import { Component as BaseComponent, h } from 'preact';
import { connect } from 'preact-redux';
import PromoMessage from '../promo-message';
import DatePicker from '../date-picker';
import { MediaQuery as MQ } from '../../media-query';

class Component extends BaseComponent {
    componentWillMount() {
        if (this.props.slant) {
            this.props.requireHoroscope(this.props.date, this.props.sign, `${this.props.slant}_daily`);
            this.setState({ base_url: `/daily-${this.props.slant}-horoscope` });
        } else {
            this.props.requireHoroscope(this.props.date, this.props.sign, 'horoscopes_daily');
            this.setState({ base_url: '/daily-horoscope' });
        }
    }

    shouldComponentUpdate(nextProps) {
        if (nextProps.user.logged_in != this.props.user.logged_in) {
            if (this.props.slant) {
                this.props.requireHoroscope(this.props.date, this.props.sign, `${this.props.slant}_daily`);
            } else {
                this.props.requireHoroscope(this.props.date, this.props.sign, 'horoscopes_daily');
            }
        }

        return true;
    }

    render({ horoscope }) {
        if (horoscope) {
            return (
                <daily-horoscope>
                    {this.renderDatePicker()}
                    {this.renderLinks()}
                    <h1>{horoscope.h2_text}</h1>
                    <div class='daily-links'>
                        <a href={`/bios/${horoscope.author_slug}`}>by {horoscope.author}</a>
                    </div>
                    <br />
                    {this.renderHoroscope()}
                    <p>
                        <PromoMessage
                          placement={this.props.slant ? `text-${this.props.slant}-horoscope` : 'text-horoscope'}
                        />
                    </p>
                </daily-horoscope>
            );
        }

        return (
            <daily-horoscope />
        );
    }

    renderDatePicker = () => {
        if (!MQ.isMobile()) {
            return (
                <DatePicker
                  class='icon-24x23-calendar js-datepicker'
                  url={`${this.state.base_url}/${this.props.horoscope.sign}/:date`}
                />
            );
        }

        return null;
    }

    renderLinks = () => {
        if (this.props.horoscope && this.props.horoscope.date_sel) {
            const links = this.props.horoscope.date_sel.links;

            return (
                <div class='daily-links'>
                    {Object.keys(links).map(link => {
                        return (
                            <a
                              href={`${this.state.base_url}/${this.props.horoscope.sign}/${links[link].query}`}
                              class={links[link].selected ? 'selected' : ''}
                            >
                                {links[link].title}
                            </a>
                        );
                    })}
                </div>
            );
        }

        return null;
    }

    renderHoroscope = () => {
        if (this.props.horoscope && this.props.horoscope.scope_txt) {
            return this.props.horoscope.scope_txt.split('\n').map((p, key) => {
                if (key === 0) {
                    return (
                        <p>
                            <b>{this.props.horoscope.date}:</b>&nbsp;
                            {p}
                            {this.renderContinue()}
                        </p>
                    );
                }

                return (
                    <p>{p}</p>
                );
            });
        }

        return null;
    }

    renderContinue = () => {
        if (this.props.horoscope && this.props.horoscope.continue) {
            return (
                <a href={this.props.horoscope.continue}>Continue</a>
            );
        }

        return null;
    }
}

const mapStateToProps = (state) => ({
    horoscope: state.horoscope,
    user: state.user,
});

const mapDispatchToProps = (dispatch) => ({
    requireHoroscope: (date, sign, type) => dispatch({
        type: 'horoscope:require',
        payload: {
            date: date,
            sign: sign,
            type: type,
        },
    }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);



// WEBPACK FOOTER //
// ./app/components/daily/horoscope.js